import { councilDashboardApi } from "@/lib/api"
import type { ApiResponseListRecentUserDTO } from "@/gen/api"
import { useQuery } from "@tanstack/react-query"

const useGetRecentCustomers = (councilId: number) => {
  return useQuery({
    queryKey: [useGetRecentCustomers.QUERY_KEY, councilId],
    queryFn: async () => {
      const response = await councilDashboardApi.getRecentUsers(councilId)
      return (response.data as ApiResponseListRecentUserDTO).data ?? []
    },
    enabled: !!councilId,
  })
}

useGetRecentCustomers.QUERY_KEY = "recent-customers"

export default useGetRecentCustomers
